module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"choose":"Ou escolha uma seleção existente","create":"Crie uma nova seleção","error":"Escolha uma seleção ou cancele esta operação","title":"Adicionar mídias a uma seleção","added":"As mídias foram adicionadas à seleção"}}')
  delete Component.options._Ctor
}
